import React from 'react';
import { PlusOutlined, CloseCircleFilled } from '@ant-design/icons';
import { Button, Form, Input, Popconfirm, Select, Space, Typography, Checkbox, Row } from 'antd';



const { Text } = Typography;
const Option = Select;



const EventForm = ({ handleAdd, form, formData, disabled }) => {
    return (
        <>
            <Space>
                <Form.Item
                    name={"grouping"}
                    label={<Text strong style={{ fontSize: "15px", margin: "0px" }}>Events:</Text>}
                    rules={[
                        {
                            required: true,
                            message: "Column value required",
                        },
                    ]}
                >
                    <Select style={{ width: "30vh" }} placeholder="Select Option">
                        <Option value={"elasticSearch"}>Elastic Search</Option>
                        <Option value={"smsBridge"}>SMS Bridge</Option>
                        <Option value={"web"}>Web</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"entity"}
                    label={<></>}
                rules={[
                    {
                        required: true,
                        message: 'enter description',
                    },
                ]}
                >
                    <Select
                        placeholder='Select entity'
                        style={{ width: "30vh" }} >
                        <Option value={"elasticSearh"}>Elastic Search</Option>
                        <Option value={"smsBride"}>SMS Bridge</Option>
                        <Option value={"web2"}>Web</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"action"}
                    label={<></>}
                rules={[
                    {
                        required: true,
                        message: "position required",
                    },
                ]}
                >
                    <Select style={{ width: "30vh" }} placeholder="Select action" >
                    <Option value={"elasticSearc"}>Elastic Search</Option>
                        <Option value={"smsBridg"}>SMS Bridge</Option>
                        <Option value={"web3"}>Web</Option>
                    </Select>
                </Form.Item>
                <Button
                    onClick={handleAdd}
                    type="primary"
                    icon={<PlusOutlined />}
                    style={{ backgroundColor: "#15CCAE", color: "white", marginLeft: "auto",marginTop: 5 }}
                >
                </Button>
            </Space>
        </>
    );
};

export default EventForm;

